import { API } from 'aws-amplify';
import { ISummary } from 'src/types';
import { IActiveRequest } from 'src/types/org/updateRequest';
import { processResponse } from 'src/utils/api';

export const active = async (params: IActiveRequest) => {
  const response: ISummary[] = await API.post('AiFormRequest', '/save?key=activeUpdateRequests', {
    body: params,
  }).then(response => processResponse(response));
  return response;
};

/**
 *
 * @param params
 * @returns
 */
interface ISearchActive {
  active: ISummary[];
  owned: ISummary[];
}

export const searchActive = async (params: IActiveRequest) => {
  const response: ISearchActive = await API.post('AiFormRequest', '/save?key=getUpdateRequests', {
    body: params,
  }).then(response => processResponse(response));
  return response;
};
